import { useEffect, useState } from "react";

const COUNTRIES_URL = "/json/countries.json";

// One request for the whole app: every phone field shares this promise, so a
// page with four phone fields still downloads the list only once.
let countriesRequest = null;

const loadCountries = () => {
    if (!countriesRequest) {
        countriesRequest = fetch(COUNTRIES_URL)
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.json();
            })
            .catch((error) => {
                // Forget the failed request so the next field to mount retries.
                countriesRequest = null;
                console.error("Could not load the country list:", error);
                return [];
            });
    }
    return countriesRequest;
};

/**
 * The country list used by phone-number fields:
 * [{ name: "Japan", flag: "🇯🇵", code: "JP", dial_code: "+81" }, …]
 * Empty until it has loaded.
 */
const useCountries = () => {
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        let isMounted = true;
        loadCountries().then((loadedCountries) => {
            if (isMounted) setCountries(loadedCountries);
        });
        return () => {
            isMounted = false;
        };
    }, []);

    return countries;
};

export default useCountries;
